import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import {
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
  CardImgOverlay,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import LoadingSpinner from "../Common/LoadingSpinner";
import { get } from "../../Code/IApi";

export default class CharityDetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      errMsg: null,
      charityDetail: null,
    };

    this.changeSelectedCharity = this.changeSelectedCharity.bind(this);
  }

  async changeSelectedCharity() {
    this.setState({ loading: true, errMsg: null, charityDetail: null });

    let { charity } = this.props;
    if (charity) {
      // The fetching function in Data.js returns whether successful or not
      const response = await get(`charity/${charity.CharityId.toString()}`);

      if (response.Succeeded) {
        this.setState({ charityDetail: response.CharityInfo, loading: false });
      } else {
        this.setState({ errMsg: response.ErrorMessage, loading: false });
      }
    }
  }

  async componentDidMount() {
    await this.changeSelectedCharity();
  }

  async componentDidUpdate(prevProps) {
    if (this.props.charity !== prevProps.charity) {
      await this.changeSelectedCharity();
    }
  }

  render() {
    const { isOpen, charity, selected, onClose, makeSelection } = this.props;
    const { loading, errMsg, charityDetail } = this.state;

    let modalContents = null;
    if (loading) {
      modalContents = (
        <ModalBody>
          <LoadingSpinner />
          <ModalFooter>
            <Button color="primary" onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalBody>
      );
    } else if (errMsg) {
      modalContents = (
        <Fragment>
          <ModalHeader>Error Loading Charity</ModalHeader>
          <ModalBody>
            <p>{errMsg}</p>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </Fragment>
      );
    } else if (charityDetail) {
      const {
        CharityName,
        CategoryName,
        Locations,
        ShortDescription,
        LongDescription,
        LogoURL,
        Url,
        IsLocal,
      } = charityDetail;

      modalContents = (
        <Fragment>
          <Card className="charity-card small">
            <div className="position-relative">
              {LogoURL ? (
                <img
                  src={LogoURL}
                  onError={e => {
                    e.target.onerror = null;
                    e.target.src = "images/default.png";
                  }}
                  alt={CharityName}
                />
              ) : (
                <div className="img-name">{CharityName}</div>
              )}
              <CardImgOverlay className="text-right">
                <UncontrolledDropdown onClick={e => e.stopPropagation()}>
                  <DropdownToggle size="sm" color="primary" className="aaaa">
                    <i className="fa fa-ellipsis-v" />
                  </DropdownToggle>

                  <DropdownMenu right>
                    <DropdownItem
                      tag={Link}
                      onClick={this.closeNavbar}
                      to={`/Purchase?CID=${charity.CharityId}`}>
                      Purchase
                    </DropdownItem>
                    <DropdownItem
                      tag={Link}
                      onClick={this.closeNavbar}
                      to={`/Purchase/HonorCards?CID=${charity.CharityId}`}>
                      Honor Cards
                    </DropdownItem>
                    <DropdownItem
                      tag={Link}
                      onClick={this.closeNavbar}
                      to={`/Purchase/DirectToCharityDonation?CID=${charity.CharityId}`}>
                      Donate Directly
                    </DropdownItem>
                    <DropdownItem
                      tag={Link}
                      onClick={this.closeNavbar}
                      to={`/Redeem?CID=${charity.CharityId}`}>
                      Redeem
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </CardImgOverlay>
            </div>
            <CardBody>
              {LogoURL && (
                <p className="name">
                  <b>{CharityName}</b>
                </p>
              )}
              {CategoryName && (
                <p>
                  <b>Charity Category:</b> {CategoryName}
                </p>
              )}
              {IsLocal && Locations && (
                <p>
                  <b>Location:</b> {Locations.join(", ")}
                </p>
              )}
              <p className="short-desc" style={{ WebkitBoxOrient: "vertical" }}>
                {ShortDescription}
              </p>
              {LongDescription && (
                <p
                  className="short-desc"
                  style={{ WebkitBoxOrient: "vertical" }}>
                  {LongDescription}
                </p>
              )}
              {Url && (
                <a target="_blank" rel="noopener noreferrer" href={Url}>
                  {Url}
                </a>
              )}
              <Row className="mt-3">
                <Button
                  color={selected ? "success" : "primary"}
                  size="sm"
                  onClick={() => makeSelection(charity)}>
                  {selected
                    ? "You have Selected this Charity"
                    : "Select this Charity"}
                </Button>
                <Button color="primary" size="sm" onClick={onClose}>
                  Close
                </Button>
              </Row>
            </CardBody>
          </Card>
        </Fragment>
      );
    }

    return (
      <Modal
        className="charity-detail-modal"
        isOpen={isOpen}
        toggle={onClose}
        backdrop={false}>
        {modalContents}
      </Modal>
    );
  }
}
